


















import Vue from 'vue';
import { deviceMixin } from '@/mixins/device';
import { ImageFormat } from '@/constants/imageFormat';

export default Vue.extend({
  name: 'HotelImageCarousel',
  mixins: [deviceMixin],
  props: {
    room: {
      type: Object,
      default: null,
    },
    showList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasListeners: false,
      moreImages: false,
      prevCount: 10,
      selectedPhoto: 0,
      touchCoords: 0,
      swipeWidth: 0.3,
    };
  },
  computed: {
    roomName(): string {
      if (!this.room || !this.room.name) {
        return '';
      }
      return this.room.name[(this as any).i18nTag()] ? this.room.name[(this as any).i18nTag()] : this.room.name.en;
    },
    roomPhotos(): Array<any> {
      const imageFormat = (this as any).imageFormat as ImageFormat | undefined;
      if (!imageFormat) {
        return [];
      }
      const photos = [] as Array<any>;
      for (let i = 0; i < this.room.images.length; i++) {
        photos.push({
          url: this.room.images[i][imageFormat],
          position: this.room.images[i].position,
          thumbnail: this.room.images[i].thumbnail,
        });
      }
      return photos.sort((a: any, b: any) => (a.position > b.position ? 1 : -1));
    },
    galleryBg(): string | boolean {
      if (this.roomPhotos && this.roomPhotos[this.selectedPhoto]) {
        return `url('${this.roomPhotos[this.selectedPhoto].url}')`;
      }
      return false;
    },
    showLess(): boolean {
      return this.moreImages && this.roomPhotos.length > this.prevCount;
    },
    itemMaxWidth(): string {
      const percent = Math.ceil(100 / (this.roomPhotos.length > 10 ? 10 : this.roomPhotos.length));
      return 'calc(' + percent + '% - 2px)';
    },
  },
  watch: {
    roomPhotos() {
      this.selectedPhoto = 0;
      this.moreImages = false;
    },
  },
  updated() {
    if (!this.hasListeners) {
      const container = this.$refs.carouselBodySwipe as HTMLElement;
      if (container) {
        this.hasListeners = true;
        container.addEventListener('touchstart', this.swipeStart, false);
        container.addEventListener('touchmove', this.swipeHandler, {
          passive: false,
        });
      }
    }
  },
  beforeDestroy() {
    if (this.hasListeners) {
      const container = this.$refs.carouselBodySwipe as HTMLElement;
      if (container) {
        container.removeEventListener('touchstart', this.swipeStart);
        container.removeEventListener('touchmove', this.swipeHandler);
      }
    }
  },
  methods: {
    isMorePrev(index: number): boolean {
      return !this.moreImages && index === this.prevCount - 1 && this.roomPhotos.length > this.prevCount;
    },
    classList(index: number): Object {
      return {
        'carousel-item--active': index === this.selectedPhoto,
        'carousel-item--more': this.isMorePrev(index),
      };
    },
    selectPhoto(index: number): void {
      if (this.isMorePrev(index)) {
        this.moreImages = !this.moreImages;
      } else {
        this.selectedPhoto = index;
      }
    },
    prevItem(): void {
      if (this.roomPhotos.length) {
        if (this.selectedPhoto != 0) {
          this.selectedPhoto--;
        } else {
          this.selectedPhoto = this.roomPhotos.length - 1;
        }
      }
    },
    nextItem(): void {
      if (this.roomPhotos.length) {
        if (this.selectedPhoto != this.roomPhotos.length - 1) {
          this.selectedPhoto++;
        } else {
          this.selectedPhoto = 0;
        }
      }
    },
    swipeStart(e: any): void {
      const touch = e.originalEvent
        ? e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
        : e.touches[0] || e.changedTouches[0];
      this.touchCoords = touch.pageX;
    },
    swipeHandler(e: any): void {
      const container = this.$refs.carouselBodySwipe as HTMLElement;
      if (container) {
        const touch = e.originalEvent
          ? e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
          : e.touches[0] || e.changedTouches[0];
        const distX = this.touchCoords - touch.pageX;
        const destination = container.clientWidth * this.swipeWidth;
        if (distX >= destination || distX <= -destination) {
          e.cancelBubble = true;
          if (e.cancelable) {
            this.touchCoords = touch.pageX;
            e.preventDefault();
            e.stopPropagation();
          }
          if (distX >= destination) {
            this.nextItem();
          } else {
            this.prevItem();
          }
        }
      }
    },
  },
});
